module.exports = __webpack_public_path__ + "img/16581293_L.a68a4b68.png";